/* PRELUDIO v12 - scheda prodotto: cuore wishlist fisso su tutte le foto; "Disponibile anche in" con riquadri uguali e colore attuale segnato */
(function () {
  function sposta() {
    var g = document.querySelector('product-gallery'), w = document.querySelector('.swym-atw-btn-wrapper-for-img');
    if (!g || !w) return false;
    var box = w.querySelector('.swym-atw-button-container'); if (!box) return false;
    if (w.parentElement !== g) g.appendChild(w);
    var c = g.querySelector('.product-gallery__carousel'), m = g.querySelector('.product-gallery__media');
    if (!c || !m) return true;
    var gr = g.getBoundingClientRect(), cr = c.getBoundingClientRect();
    var largo = Math.min(m.getBoundingClientRect().width, cr.width);
    box.style.setProperty('left', Math.round(cr.left - gr.left + largo - 52) + 'px', 'important');
    box.style.setProperty('right', 'auto', 'important');
    box.style.setProperty('top', Math.round(cr.top - gr.top + 12) + 'px', 'important');
    return true;
  }
  function varianti() {
    var qui = location.pathname.replace(/\/$/, '');
    document.querySelectorAll('.varianti-atelier-list a').forEach(function (a) {
      var p = ''; try { p = new URL(a.href, location.origin).pathname.replace(/\/$/, ''); } catch (e) {}
      var li = a.closest('li'); if (!li) return;
      if (p === qui) { li.classList.add('pl-attuale'); a.setAttribute('aria-current', 'true'); }
    });
  }
  var timer = null;
  function cerca() {
    var n = 0; if (timer) clearInterval(timer);
    timer = setInterval(function () { varianti(); if (sposta() || ++n > 40) { clearInterval(timer); timer = null; } }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cerca); else cerca();
  window.addEventListener('resize', sposta);
  document.addEventListener('variant:change', function () { setTimeout(cerca, 300); });
})();
